import React, { useContext, useEffect, useState } from 'react';
import { IconButton, Paper, TableBody, TextField, Table, TableCell, TableContainer, TableHead, TableRow, Box, Stack, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import { Edit, Close, Visibility } from '@mui/icons-material';
import EditServiceDialog from './EditServiceDialog';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import { ProviderServices } from '../CrudServices';
import { UserProfileContext } from '../UserProfile';
import Swal from 'sweetalert2';
import useResponsive from '../../../hooks/useResponsive';
import { RoleGuard } from '../../../components/RoleGuard';
import { ProviderServicesContext } from './ServiceDetails';

const ServiceTable = (props) => {
  const {isXs,isSm,isMd,isLg,isXl} = useResponsive();
    const {providerServiceList,fetchProviderServiceList,providerServiceModal} = useContext(ProviderServicesContext);
    const {serviceDetailsData,setServiceDetailsData} = useContext(UserProfileContext);
    const [selectedServiceToEdit,setSelectedServiceToEdit] = useState({});
    const [openUpdateDialog,setOpenUpdateDialog] = useState(false);

    const onSelectForEdit = async(data)=>{
      // console.log("selected service data:",data);
      const result = await Swal.fire({
        text: "Do you want to Edit Service now?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit now!',
        cancelButtonText: 'No, Cancel',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false,
      });

      if (result.isConfirmed) {
         try {
          // Show loading state
          Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we processing your request',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
          // Make the API call
          const serviceId = data.id;
          const serviceDetailsResponse = await ProviderServices.fetchProviderServiceDetailsById({serviceId:serviceId});
          // console.log("service details Response:",serviceDetailsResponse);
    
          // Close loading dialog and show success/error message
          if(serviceDetailsResponse.success =='1'){
            const serviceDetails = serviceDetailsResponse.data;
            // console.log("service details:",serviceDetails);
            const services = serviceDetails?.childService?.ServiceCategoryRels[0];
            const requiredData = {
              id: serviceDetails?.id,
              vistingCharge: serviceDetails?.providerServiceCharge?.vistingCharge,
              additionalCharge: serviceDetails?.providerServiceCharge?.additionalCharge,
              cancellationChargeInPercent: serviceDetails?.providerServiceCharge?.cancellationChargeInPercent,
              timeLimitForCancellation: serviceDetails?.providerServiceCharge?.timeLimitForCancellation,
              isRefundable: serviceDetails?.providerServiceCharge?.refundableAmount != 0 && serviceDetails?.providerServiceCharge?.refundableDuration!=0 ? true : false,
              refundableAmount: serviceDetails?.providerServiceCharge?.refundableAmount,
              refundableDuration: serviceDetails?.providerServiceCharge?.refundableDuration,  
              serviceCategoryId: services?.ServiceCategory?.parentId,        
              subCategoryId: data?.subCategoryId,
              servicesMasterId: data?.servicesMasterId,
              servicesChildId: data?.servicesChildId,
              categoryId: services?.ServiceCategory?.parentId,
              subCategoryId: data?.subCategoryId,
              categoryTitle: '',
              subCategoryTitle: data?.subCategoryTitle,
              masterServiceTitle: data?.masterServiceTitle,
              childServiceTitle: data?.childServiceTitle,
              serviceTime: data?.serviceTime,
              price: data?.price,
              service: data?.servicesMasterId,
              brandTitle: serviceDetailsResponse.data?.brd?.title
            }
            // Close the loading dialog first
            Swal.close();
            
            // Set selected service and open update dialog
            setSelectedServiceToEdit(requiredData);
            setOpenUpdateDialog(true);
            
            return true;
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: serviceDetailsResponse.message || 'Failed to fetch service data for edit'
            });
            return false;
          }
        } catch (error) {
          // console.error("fetching service data for edit:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'An error occurred while fetching service data for edit'
          });
          return false;
        }
      } else {
        return false;
      }
      // fetchServicedetails(data);
      
    }
    const handleRemoveService =async (serviceId)=>{
      // console.log("serviceId:",serviceId);
      const result = await Swal.fire({
        text: "Do you want to Delete Service now?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Delete now!',
        cancelButtonText: 'No, Cancel',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false,
      });
    
      if (result.isConfirmed) {
        try {
          // Show loading state
          Swal.fire({
            title: 'Processing...',
            text: 'Please wait while we deleting service',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
    
          // Make the API call
          const serviceDeleteResponse = await ProviderServices.deleteProviderService(serviceId);;
          // console.log("service delete response:", serviceDeleteResponse);
    
          // Close loading dialog and show success/error message
          if (serviceDeleteResponse.success === 1) {
            await fetchProviderServiceList({
              providerId:serviceDetailsData.providerId,
              page:controller.page+1, 
              pageSize:controller.pageSize,
            }); 
            await Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: serviceDeleteResponse.message || 'service deleted successfully',
              timer: 1500
            });
            
            return true;
          } else {
            await Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: serviceDeleteResponse.message || 'Failed to delete service'
            });
            return false;
          }
    
        } catch (error) {
          // console.error("Error deleting member:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'An error occurred while deleting the member'
          });
          return false;
        }
      } else {
        return false;
      }
  }
    const [descriptionModal, setDescriptionModal] = useState({ open: false, title: '', description: '' });
    const handleViewDetail = (title, description) => {
      setDescriptionModal({ open: true, title, description });
    };
    const handleCloseDescriptionModal = () => {
      setDescriptionModal({ open: false, title: '', description: '' });
    };

    const handleClose =()=>{
        fetchProviderServiceList({
            providerId:serviceDetailsData.providerId,
            page:controller.page+1,
            pageSize:controller.pageSize,
        });
        setOpenUpdateDialog(false)
    }

    /* =====================datagrid table related =========================*/
    const [loading, setLoading] = useState(false);
    const [allRowCount, setAllRowCount] = useState(0);
    const [controller, setController] = useState({
        page: 0,
        pageSize: 50,
        filters: {
          searchKey: "",
          status: 1,
        }
    });

    const handlePaginationChange = (newPagination) => {
        setController({
          ...controller,
          page: newPagination.page,
          pageSize: newPagination.pageSize
        });
    }

    const columns = [
        {
            field: 'serialNumber',
            headerAlign: 'center',
            headerName: 'S.No',
            width: 100,
            flex:.5,
            valueGetter: (params) => 
              controller.page * controller.pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id)+1,
        },
        {
            field:'subCategoryTitle', headerAlign: 'center', headerName: "Category Details", flex: 2,editable: false,
            renderCell:(params)=>{
              return (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row.subCategoryTitle}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>
                        ({params.row.subCategoryId})
                      </Box>
                    </RoleGuard>
                  </Typography>
                  <Typography variant='caption' sx={{ fontWeight: 400, fontSize: '0.5rem' }}>({` ${params.row.categoryTile} `}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{  fontWeight: 600, color: '#382cd5' }}>
                        _{params.row.categoryId}
                      </Box>
                    </RoleGuard>
                  )
                  </Typography>
                </Box>
              )
            }
        },
        {
            field:'masterServiceTitle', headerAlign: 'center', headerName: "Service Details", flex: 2,editable: false,
            renderCell:(params)=>{
              console.log('data childer',params)
              return(
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Typography variant='body2' sx={{ fontWeight: 600, fontSize: '0.7rem' }}>{params.row.childServiceTitle}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>
                        ({params.row.servicesChildId})
                      </Box>
                    </RoleGuard>
                  </Typography>
                  <Typography variant='caption' sx={{ fontWeight: 400, fontSize: '0.5rem' }}>({` ${params.row.masterServiceTitle} `}
                    <RoleGuard role={['Super Admin','Admin']}>
                      <Box component="span" sx={{  fontWeight: 600, color: '#382cd5' }}>
                        _{params.row.servicesMasterId}
                      </Box>
                    </RoleGuard>
                  )
                  </Typography>
                </Box>
              )
            }
        },
        {
          field:'brand', headerAlign: 'center', headerName: "Variation", flex: 1,editable: false,
          renderCell:(params)=>{  
            return(
              <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                <Typography sx={{fontSize:'.75rem'}}>{params.row?.brand?.title || ''}</Typography>
              </Box>
            )
          }          
        },
        {
          field:'detail', headerAlign: 'center', headerName: "Detail", flex: .7,editable: false, sortable: false, filterable: false,
          renderCell:(params)=>{
            return(
              <Button size="small" variant="outlined" sx={{ fontSize: '0.55rem', textTransform: 'capitalize' }} onClick={() => handleViewDetail(params.row.childServiceTitle, params.row.description)}>
                View Description
              </Button>
            )
          }
        },
        {
          field:'serviceTime', headerAlign: 'center', headerName: "Service Time", flex: .85,editable: false,
          renderCell:(params)=>{  
            return(
              <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                <Typography sx={{fontSize:'.75rem'}}>{params.row.serviceTime} mins.</Typography>
              </Box>
            )
          }          
        },
        {
            field:'price', headerAlign: 'center', headerName: "Price", flex: 1,editable: false,
            renderCell:(params)=>{  
              return(
                <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                  <Typography sx={{fontSize:'.75rem'}}>₹ {params.row.price}</Typography>
                </Box>
              )
            }
        },
        {
          field:'visitingCharge', headerAlign: 'center', headerName: "Visiting Charge", flex: .75,editable: false,
          renderCell:(params)=>{  
            return(
              <Box sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                <Typography sx={{fontSize:'.75rem'}}>₹ {params.row.visitingCharge}</Typography>
              </Box>
            )
          }
        },
        {field: 'action', headerAlign: 'center', headerName: 'Action', sortable: false, flex: .5,
          renderCell: (params) => {
            return (
              <Stack direction="row" spacing={1}>
                <IconButton
                  onClick={() => onSelectForEdit(params.row)}
                  size="small"
                  color='warning'
                >
                  <Edit fontSize="small" />
                </IconButton>
                <IconButton
                  onClick={() => handleRemoveService(params.row.id)}
                    color='error'
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Stack>
            );
          },
        },
    // {
    //   field: "name", headerAlign: 'center', headerName: "Name", flex: 1, editable: false, valueGetter: (params) => {
    //     return `${params.row.profile.firstName} ${params.row.profile.middleName} ${params.row.profile.lastName}`;
    //   }
    // },
    ]

  useEffect(()=>{
    if(serviceDetailsData.providerId>0){
      // console.log("fjghkehgkejhgkjehrkj:",{
      //   providerId:serviceDetailsData.providerId,
      //   page:controller.page+1,
      //   pageSize:controller.pageSize,
      // })
    fetchProviderServiceList({
        providerId:serviceDetailsData.providerId,
        page:controller.page+1,
        pageSize:controller.pageSize,
    });
    }
  },[controller,serviceDetailsData]);
  useEffect(()=>{
    setAllRowCount(providerServiceModal?.totalItems);
  },[])
  return (
    <>
    {openUpdateDialog && <EditServiceDialog serviceData={selectedServiceToEdit} onClose={handleClose} openUpdateDialog={openUpdateDialog} />}
        <Box sx={{ overflow: "auto" }}>
            <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff",borderRadius:'.5rem' }}>
                <DataGrid
                    rows={providerServiceList}
                    columns={columns.map((col) => ({
                      ...col,
                      // flex: isSmallScreen && (col.flex || 1), // Ensure columns resize dynamically
                      minWidth: isSm && (col.minWidth || 150), // Set a minimum width to avoid overlap
                    }))}
                    getRowId={(row) => row.id}
                    //checkboxSelection={true}
                    rowCount={allRowCount}  // Use the length of the filtered list
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    paginationModel={controller}
                    paginationMode="server"
                    onPaginationModelChange={handlePaginationChange}

                    loading={loading}

                    disableColumnMenu
                    disableRowSelectionOnClick
                    slots={{
                        // toolbar: GridToolbar,
                        noRowsOverlay: NoRowsLayout,
                    }}

                    autoHeight
                    getRowHeight={() => 'auto'}
                    sx={{
                      lineHeight:1,
                      '& .MuiDataGrid-cell': {
                        border: 1,
                        borderRight: 0,
                        borderTop: 0,
                        borderColor: 'lightgrey',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p:'.5%',fontSize:'.75rem'
                      },
                      '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                        borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p:0,
                        height: 'fit-content',
                        minHeight:'0 !important',
                        height:'2rem'
                      },
                      '& .MuiDataGrid-columnHeader': {
                        borderLeft: '1px solid rgba(224, 224, 224, 1)',
                        '&:last-child': {
                          borderRight: 'none',
                        },
                      },
                      '& .MuiDataGrid-columnHeaderTitle': {
                        fontWeight: 600,
                        color: '#3e3e3e'
                      },
                      '& .MuiDataGrid-row': {
                        '&:last-child .MuiDataGrid-cell': {
                          borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        },
                        '& .MuiDataGrid-cell:last-child': {
                          borderRight: 'none',
                        },
                      },
                      '& .MuiDataGrid-columnSeparator': {
                        display: 'none',
                      },
                    }}
                />
            </Box>
        </Box>
      <Dialog open={descriptionModal.open} onClose={handleCloseDescriptionModal} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.85rem', fontWeight: 600 }}>
          {descriptionModal.title}
          <IconButton size="small" onClick={handleCloseDescriptionModal}><Close fontSize="small" /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ fontSize: '0.75rem' }} dangerouslySetInnerHTML={{ __html: descriptionModal.description || 'No description available' }} />
        </DialogContent>
        <DialogActions>
          <Button size="small" onClick={handleCloseDescriptionModal} variant="outlined">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ServiceTable;
